<div class="flex flex-col gap-3">
  <label class="flex flex-col gap-1">
    <span class="text-sm font-medium">Recurso</span>
    <app-select
      [options]="opcionesRecursos()"
      (onChange)="onRecursoChange($event)"
      placeholder="Seleccione un recurso"
      class="w-full"
    />
  </label>

  <label class="flex flex-col gap-1">
    <span class="text-sm font-medium">Fecha</span>
    <app-datepicker (onSelect)="onFechaChange($event)" dateFormat="yy-mm-dd" class="w-full" />
  </label>

  @if (recursoActivo()) {
    <label class="flex flex-col gap-1">
      <span class="text-sm font-medium">Duración del turno (minutos)</span>
      <div class="flex items-center gap-2">
        <input
          type="number"
          [ngModel]="duracionMinutos()"
          (ngModelChange)="onDuracionChange($event)"
          class="rounded-lg border border-slate-200 p-2 w-20 text-sm focus:outline-none focus:ring-2 focus:ring-accent-500/20 focus:border-accent-500"
          min="5"
          max="480"
          step="5"
        />
        <span class="text-xs text-slate-400"
          >Por defecto: {{ recursoActivo()?.duracion_minutos }}min</span
        >
      </div>
    </label>
  }

  @if (disponibilidad(); as disp) {
    <div class="border border-slate-200 rounded-xl p-3">
      <p class="text-sm font-medium mb-2">
        Horarios disponibles - {{ disp.fecha }}
        @if (recursoActivo(); as rec) {
          <span class="text-xs text-slate-400 ml-2"
            >({{ rec.duracion_minutos }}min por defecto)</span
          >
        }
      </p>
      @if (slotsGenerados().length === 0) {
        <p class="text-sm text-slate-500">
          @if (disp.horario_laboral.length === 0) {
            No hay horario de atención configurado para este día.
          } @else {
            No hay slots disponibles con la duración seleccionada ({{ duracionMinutos() }}min).
          }
        </p>
      } @else {
        <div class="grid grid-cols-3 sm:grid-cols-4 gap-2">
          @for (slot of slotsGenerados(); track slot.hora_inicio) {
            <button
              type="button"
              class="p-2 rounded-lg text-sm border text-center transition-colors"
              [class.bg-emerald-50]="
                slot.disponible && slotSeleccionado()?.hora_inicio === slot.hora_inicio
              "
              [class.border-emerald-400]="
                slot.disponible && slotSeleccionado()?.hora_inicio === slot.hora_inicio
              "
              [class.border-slate-200]="
                slot.disponible && slotSeleccionado()?.hora_inicio !== slot.hora_inicio
              "
              [class.bg-slate-100]="!slot.disponible"
              [class.text-slate-400]="!slot.disponible"
              [class.border-slate-100]="!slot.disponible"
              [class.cursor-pointer]="slot.disponible"
              [class.cursor-not-allowed]="!slot.disponible"
              [class.hover:bg-emerald-50]="slot.disponible"
              [disabled]="!slot.disponible"
              (click)="seleccionarSlot(slot)"
            >
              {{ slot.hora_inicio.substring(0, 5) }} - {{ slot.hora_fin.substring(0, 5) }}
            </button>
          }
        </div>
      }
    </div>
  }

  <label class="flex flex-col gap-1">
    <span class="text-sm font-medium">Nombre del cliente</span>
    <input
      [formField]="formReserva.nombre_cliente_no_registrado"
      type="text"
      class="w-full"
      placeholder="Opcional"
    />
  </label>

  <label class="flex flex-col gap-1">
    <span class="text-sm font-medium">Teléfono</span>
    <input
      [formField]="formReserva.telefono_cliente_no_registrado"
      type="text"
      class="w-full"
      placeholder="Opcional"
    />
  </label>

  <label class="flex flex-col gap-1">
    <span class="text-sm font-medium">Notas internas</span>
    <textarea
      [formField]="formReserva.notas"
      class="w-full"
      rows="2"
      placeholder="Notas internas"
    ></textarea>
  </label>

  <label class="flex flex-col gap-1">
    <span class="text-sm font-medium">Notas para el cliente</span>
    <textarea
      [formField]="formReserva.notas_cliente"
      class="w-full resize-none"
      rows="2"
      placeholder="Mensaje para el cliente"
    ></textarea>
  </label>

  <div class="flex justify-end gap-2 pt-2">
    <app-button label="Cancelar" variant="secondary" (onClick)="onCerrar()" />
    <app-button label="Crear Reserva" (onClick)="guardar()" [disabled]="!slotSeleccionado()" />
  </div>
</div>
